import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip, Button } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/presensiService"

import SimulationBloc from '../Blocs/SimulationBloc'
import apiResponse from '../../../../../services/apiResponse'

import ReactTimeAgo from 'react-time-ago'
import moment from "moment"

class SimulationHonorerComponent extends Component {
    simulationBloc = new SimulationBloc()

    source

    constructor(props) {
        super(props)
        this.state = {
            loadingTable: false,
            cancelDate: null,
            rows: [],
        }
    }

    getIconPresensi = (inp, val) => {
        if (inp != null) {
            if (val == 'Finger Print') {
                return (
                  <>
                    <br /> <i className="bx bx-fingerprint"></i>
                  </>
                )
            }
    
            if (val == 'Mobile') {
                return (
                  <>
                    <br /> <i className="bx bx-mobile-alt"></i>
                  </>
                )
            }
        }
        return '';
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    loadData = async () => {
        this.setState({loading: true})
        var filter = this.props.filter
        this.simulationBloc.fetchSimulation({uuid: this.props.uuid, ...filter});
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.cancelDate()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }


    componentDidMount() {
        this.setTokenAPI()

        this.simulationBloc.simulationChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false,
                        loading: false,
                        rows: []
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true,
                        loading: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        rows: response.result,
                        loading: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.simulationBloc.cancelChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                        this.loadData()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    cancelDate = async () => {
        const query = {
            uuid: this.props.uuid,
            date: this.state.cancelDate
        }
        await this.simulationBloc.fetchCancel(query)
    }

    componentWillUnmount() {
        this.simulationBloc.simulationChannel.unsubscribe()
    }

    render() {
        return (
            <>
                <div className="table-responsive" style={{minWidth:'100%'}}>
                    <Table
                            className="table table-striped table-bordered table-hover"
                        >
                            <Thead>
                                <Tr>
                                    <Th className="text-center" width="*">Tanggal</Th>
                                    <Th className="text-left" width="*">Hari</Th>
                                    <Th className="text-center" width="*">Masuk</Th>
                                    <Th className="text-center" width="*">Pulang</Th>
                                    
                                    <Th className="text-center" width="*">Hadir</Th>

                                    <Th className="text-center" width="*">S.Finger</Th>

                                    <Th className="text-center" width="*">Terlambat</Th>

                                    <Th className="text-center" width="*">Pulang Cepat</Th>
                                    <Th className="text-center" width="*">Keterangan</Th>
                                    <Th className="text-center" width="*">Pola Kerja</Th>
                                    
                                    {
                                        !accessRole('approve') ? 
                                            <Th className="text-center" width="*">Aksi</Th>
                                        :""
                                    }
                                </Tr>
                            </Thead>
                            <Tbody>
                                {
                                    Object.entries(this.state.rows).map((item, key) => {
                                        const thisId = item[0];
                                        let cancelAvailable = false
                                        if (item[1].result_checkin !== null && item[1].result_checkout !== null) {
                                            cancelAvailable = true
                                        }
                                        console.log(item)
                                        let color = "";
                                        if (item[1].presensi_result_type == 1 || item[1].presensi_result_type == 10) color = "text-danger";
                                        if (item[1].presensi_result_type > 1 && item[1].presensi_result_type != 10) color = "text-primary";
                                        
                                        return (
                                            <tr key={key}>
                                                <td className={`text-center ${color}`}>{  this.dateParse(item[1].presensi_result_date) }</td>
                                                <td className={`text-left ${color}`}>{ item[1].presensi_result_day_name }</td>

                                                { 
                                                    item[1].presensi_result_type != null && item[1].presensi_result_is_present == 0 ?
                                                        <>
                                                            <td className="text-center">{ item[1].presensi_result_checkin } {this.getIconPresensi(item[1].presensi_result_checkin, item[1].presensi_result_checkin_from)}</td>
                                                            <td className="text-center">{ item[1].presensi_result_checkout } {this.getIconPresensi(item[1].presensi_result_checkout, item[1].presensi_result_checkout_from)}</td>
                                                            <td className="text-center">{ item[1].presensi_result_is_present === 0 ? '-' : 'Ya' }</td>
                                                            <td className={`text-center ${color}`} colSpan="4">{ item[1].presensi_result_type_name }</td>
                                                        </>
                                                    :
                                                        <>
                                                            <td className="text-center">{ item[1].presensi_result_checkin } {this.getIconPresensi(item[1].presensi_result_checkin, item[1].presensi_result_checkin_from)}</td>
                                                            <td className="text-center">{ item[1].presensi_result_checkout } {this.getIconPresensi(item[1].presensi_result_checkout, item[1].presensi_result_checkout_from)}</td>
                                                            <td className="text-center">{ item[1].presensi_result_is_present === 0 ? '-' : 'Ya' }</td>
                                                            

                                                            <td className="text-center">{ item[1].presensi_result_is_single_finger === 0 ? '-' : '03:45:00' }</td>

                                                            <td className="text-center">{ item[1].presensi_result_late === null ? '-' : item[1].presensi_result_late }</td>

                                                            <td className="text-center">{ item[1].presensi_result_early === null ? '-' : item[1].presensi_result_early }</td>
                                                            <td className="text-left">{ item[1].presensi_type == -1 ? item[1].presensi_type_name : item[1].presensi_result_type_name }</td>
                                                            <td className="text-left">{ item[1].presensi_result_working_pattern }</td>
                                                            
                                                            { !accessRole('approve') && item[1].presensi_type == 1 && item[1].presensi_result_date <= moment().format('YYYY-MM-DD') && item[1].presensi_result_date >= moment().startOf('month').format('YYYY-MM-DD') ? 
                                                                <td className="text-center">
                                                                    <span>
                                                                        <Button
                                                                            className="btn btn-danger btn-sm" 
                                                                            id={"delete-" + thisId}
                                                                            onClick={() => {
                                                                                this.setState({
                                                                                    cancelDate: item[1].presensi_result_date,
                                                                                    confirm: true
                                                                                })
                                                                            }}
                                                                            style={{
                                                                                padding: '2px 5px'
                                                                            }}
                                                                            disabled={!cancelAvailable}>
                                                                            <i className="uil-times-circle"></i>
                                                                        </Button>
                                                                        <Tooltip
                                                                            style={{
                                                                                marginBottom: 2
                                                                            }}
                                                                            placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                                                            toggle={() => {
                                                                                this.setState({
                                                                                    ["delete" + thisId] : !this.state["delete" + thisId]
                                                                                })
                                                                            }}
                                                                        >Batalkan Kehadiran</Tooltip>
                                                                    </span>
                                                                </td>
                                                                : ""
                                                            }

                                                        </>
                                                }

                                            </tr>
                                        )
                                    })
                                }
                            </Tbody>
                        </Table>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan membatalkan data presensi ini?"

                    loadingTitle="Mengambil data"
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                </div>
            </>
        )
    }

}

export default SimulationHonorerComponent